import {jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment} from "react/jsx-runtime";import {Done as DoneIcon, MoreVert as MoreVertIcon} from '@mui/icons-material'
import * as React from 'react'
import FlatButton from '../../../../components/FlatButton'
import ProviderActions from '../../../../components/ProviderActions'
import RowInfo from '../../../../components/Row/RowInfo'
import RowInfoCopy from '../../../../components/Row/RowInfoCopy'
import useBreakpoint from '../../../../hooks/useBreakpoint'
import {Breakpoint} from '../../../../types/constEnums'













const ProviderRowBase = (props) => {
  const {
    connectButton,
    connected,
    error,
    togglePortal,
    menuRef,
    providerName,
    providerDescription,
    providerLogo,
    children
  } = props
  const isDesktop = useBreakpoint(Breakpoint.SIDEBAR_LEFT)
  return (
    _jsxs('div', { className: "relative my-4 flex w-full shrink-0 flex-col justify-start rounded-sm bg-white shadow-card"         , children: [
      _jsxs('div', { className: "flex justify-start p-row-gutter"  , children: [
        providerLogo
        , _jsxs(RowInfo, { children: [
          _jsx('div', { className: "mr-4 flex items-center align-middle leading-6 font-semibold text-slate-700"      , children: 
            providerName
          })
          , _jsxs(RowInfoCopy, { children: [providerDescription, " " ]})
          , !!error && (
            _jsx('div', { className: "text-sm text-tomato-500 [&_a]:font-semibold [&_a]:text-tomato-500 [&_a]:underline"    , children: 
              error
            })
          )
        ]})
        , _jsxs(ProviderActions, { children: [
          !connected && connectButton
          , connected && (
            _jsx(_Fragment, { children: 
              isDesktop ? (
                _jsxs(_Fragment, { children: [
                  _jsxs('div', { className: "flex items-center pr-[25px]"  , children: [
                    _jsx(DoneIcon, { className: "h-[18px] w-[18px] text-lg text-success-light"   ,} )
                    , _jsx('div', { className: "pl-[6px] text-sm font-semibold text-slate-700"   , children: "Connected"})
                  ]})
                  , _jsx(FlatButton, {
                    className: "min-w-[30px] border-slate-400 pr-0 pl-0 text-sm font-semibold text-slate-700"      ,
                    onClick: togglePortal,
                    ref: menuRef,
 children: 
                    _jsx(MoreVertIcon, { className: "h-[18px] w-[18px] text-lg"  ,} )
                  })
                ]})
              ) : (
                _jsx(FlatButton, {
                  className: "min-w-[36px] border-slate-400 pr-0 pl-0 text-sm font-semibold text-slate-700"      ,
                  onClick: togglePortal,
                  ref: menuRef,
 children: 
                  _jsx(MoreVertIcon, {} )
                })
              )
            })
          )
        ]})
      ]})
      , children
    ]})
  )
}

export default ProviderRowBase
